module.exports = __webpack_public_path__ + "img/close.8d985038.svg";